import Analytics from "src/lib/analytics";
const analytics = Analytics.event.builder().setPage('EP_Subject');
export default analytics;
